const messages = {
    tr: {
        loginInformation: "Giriş Bilgileri",
        whatIsYourPurpose: "Amacınız Nedir?",
        addingASystem: "Sistem Ekleme",
        addingAModule: "Modül Ekleme",
        letsGetToKnowYou: "Sizi Tanıyalım",
        name: "Adı",
        enterYourName: "Adınızı giriniz",
        surname: "Soyadı",
        enterYourLastName: "Soyadınızı giriniz",
        password: "Parola",
        passwordRedial: "Parola Tekrar",
        thePasswordMustComplyWithAllClauses: "Parola tüm maddelere uygun olmalıdır:",
        number: "Numara",
        eightToThirtyTwoCharacters: "8 ile 32 karakter arasında",
        upperCase: "Büyük harf",
        youCannotUseYourUsername: "Kullanıcı adınızı kullanamazsınız",
        namespaceIsRequired: "Ad alanı zorunludur!",
        theSurnameFieldIsRequired: "Soyadı alanı zorunludur!",
        RegisteredEmail: "Kayıtlı E-posta",
        siteName: "Site Adı",
        welcomeMessage: "Supsis AI Hoşgeldiniz",
        welcomeDescription: `Sizlerle tanışmak ve sizlere en uygun çözümleri sunmak isterim.<br>Lütfen adınızı girin ve giriş bilgilerinizi düzenleyin.`,
        aiExpectationsTitle: "Supsis AI Teknolojisinden ve Yapay Zekasından Beklentileriniz Nelerdir?",
        socialMediaManagementText: "Tüm Sosyal Medya ve Müşteri İletişimini Tek Ekranda Kolayca Yönetin",
        aiChatbotAutomationText: "Yapay Zeka Chatbot ile 7/24, Her Dilde İşinizi Otomatik Yönetin",
        digitalSolutionsText: "Markamın daha geniş kitlelere ulaşmasını ve tanınırlığını artırmasını sağlamak için etkili dijital çözümler kullanmak.",
        optimizeProcessesText: "İş süreçlerimi optimize etmek ve ekibimin yönetimini daha verimli bir şekilde sağlamak.",
        endToEndSolutionText: "İşletmem için insan müdahalesine gerek kalmadan uçtan uca bir çözüm sağlamak.",
        aiTechnologyExperienceText: "Yapay Zeka Teknolojisi ile Geleceği Bugün Deneyimleyin!",
        multipleSystemsText: `Birden fazla sistem seçebilir ve deneyebilirsiniz.<br />Herhangi bir indirme olmadan deneyimleyin.`,
        aiChatBotText: "AI ChatBot",
        aiChatbotManagementText: "Alanında Uzman Yapay Zeka Ekibimizle, Tüm Platformları ve Talepleri Uçtan Uca No-Code AI Chatbot ile Yönetin!",
        aiAssistantText: "AI Asistan",
        aiAssistantManagementText: "AI asistan ile tüm iş süreçlerinizi istediğiniz platformdan kolayca yönetebilir, size ve temsilcilerinize kesintisiz destek sunan süper bir asistan sahibi olabilirsiniz.",
        aiLiveSupportText: "AI Canlı Destek",
        aiLiveSupportManagementText: "AI destekli canlı destek sistemi ile tüm sosyal medya ve platformlarınızı tek bir ekrandan en gelişmiş şekilde yönetebilir, analiz edebilir ve detaylı raporlar alabilirsiniz.",
        aiAutomationText: "AI Otomosyon",
        aiAutomationManagementText: "Bütün iş kurgularınızı entegre ederek süreçlerinizi birbirine bağlar ve iş akışınızı otomatik olarak yönetmenize olanak tanır.",
        aiDynamicCrmText: "AI Dinamik Crm",
        aiDynamicCrmManagementText: "Tüm modüller ve sosyal medya platformlarıyla entegre dinamik CRM sayesinde müşteri iletişiminizi otomatik ve verimli bir şekilde yönetin.",
        customerInteractionChannelsText: "Müşterilerinizle hangi iletişim kanallarını kullanarak etkileşim kuruyorsunuz?",
        multipleSystemsSelectionText: `Birden fazla sistem seçebilir ve deneyebilirsiniz.<br>Herhangi bir indirme olmadan deneyimleyin.`,
        platformsText: "Platformlar",
        whatsappBusinessApiText: "WhatsApp Business API",
        whatsappWebText: "WhatsApp (Web)",
        instagramIntegrationText: "Instagram Entegrasyonu",
        facebookIntegrationText: "Facebook Entegrasyonu",
        telegramIntegrationText: "Telegram Entegrasyonu",
        mailManagementSystemText: "Mail Yönetim Sistemi",
        webChatText: "Web Chat",
        aiText: "Yapay Zeka",
        metaLeadTrackingText: "Meta Lead Takibi",
        trendyolIntegrationText: "Trendyol Entegrasyonu",
        linkedinIntegrationText: "LinkedIn Entegrasyonu",
        manageYourBusinessModulesText: "İşinizi Yönetmek İçin Hangi Modüllere İhtiyacınız Var?",
        allModulesAiChatbotAutomationText: `Tüm modülleri, yapay zeka chatbot, otomasyon ve <br> platformlarla tam entegre şekilde kullanabilirsiniz.`,
        modulesText: "Modüller",
        formAndSurveyModuleText: "Form & Anket Modülü",
        analyzeCustomerBehaviorText: "Tüm platformlardan web sitenize entegre edilen veriler sayesinde müşteri davranışlarını derinlemesine analiz edebilir, ihtiyaç ve beklentilerini daha iyi anlayarak onlara özel ve etkili stratejiler geliştirebilirsiniz.",
        processAndTaskManagementModuleText: "Süreç & Görev Yönetim Modülü",
        manageBusinessProcessesText: "İş süreçlerinizin şartlarını, önceliklerini ve kurallarını belirleyerek, tüm platformlar ve mobil uygulamalar üzerinden iş akışınızı ekip arkadaşlarınızla birlikte kolayca planlayabilir, takip edebilir ve yönetebilirsiniz.",
        videoAndAudioCallScreenSharingModuleText: "Görüntülü ve Sesli Görüşme & Ekran Paylaşımı Modülü",
        webChatPlatformText: "Web chat platformu sayesinde müşterilerinizle anlık mesajlaşma, dosya paylaşımı, ekran paylaşımı ve otomatik yanıtlar gibi tüm iletişim olanaklarını kullanarak kesintisiz ve mükemmel bir etkileşim sağlayabilirsiniz.",
        calendarAndReservationSystemText: "Takvim & Rezervasyon Sistemi",
        scheduleAppointmentsText: "Müşterilerinizle tüm platformlar üzerinden randevular oluşturabilir, hatırlatmalar ayarlayabilir ve yapay zeka destekli chatbot sayesinde siz uyurken bile toplantılarınızı otomatik olarak organize edebilirsiniz.",
        webSiteAnalysisAndSegmentationText: "Web Site Analizi & Segmentasyon",
        analyzeWebsiteVisitorsText: "Web sitenize gelen ziyaretçileri ayrıntılı bir şekilde analiz ederek, hangi kaynaktan geldiklerini, hangi sayfalarla ve ürünlerle ilgilendiklerini tespit eder ve detaylı segmentasyon yaparak hedef kitlenizi daha iyi tanımanıza yardımcı olur.",
        advertisingAnalysisAndReportingText: "Reklam Analizi & Raporlama",
        analyzeVisitorsAndAdsText: "Web sitenize gelen ziyaretçileri ve sosyal medya reklamlarını detaylı bir şekilde segmente ederek, ziyaretçi davranışlarını analiz eder, reklamların başarı ve geri dönüşüm oranlarını otomatik olarak hesaplar ve kapsamlı raporlar sunar.",
        ticketManagementSystemText: "Ticket Yönetim Sistemi",
        manageTicketsText: "Tüm platformlardan gelen soruları dilediğiniz zaman offline olarak yanıtlayabilir, e-posta, SMS ve WhatsApp üzerinden gelen talepleri tek bir sistemde toplayarak ticket sistemi ile kolayca yönetebilirsiniz.",
        webPushAndPopupModuleText: "Web Push & Popup Modülü",
        webPushAndPopupModuleDescriptionText: "Web sitenize gelen ziyaretçileri segmentlere ayırarak davranışlarına göre dinamik aksiyonlar alabilir, sepet hatırlatmaları yapabilir ve web siteden çıkmadan önce tetikleyiciler oluşturarak etkileşimi artırabilirsiniz.",
        reMarketingCampaignsText: "Re-Marketing Kurguları",
        reMarketingCampaignsDescriptionText: "Toplu WhatsApp mesajları, e-posta ve SMS sistemi sayesinde müşteri kitlenize anında ulaşabilir, kişiselleştirilmiş mesajlar göndererek etkileşimi artırabilir ve tüm iletişim süreçlerinizi tek bir platformdan kolayca yönetebilirsiniz.",
        dynamicTablesText: "Dinamik Tablolar",
        dynamicTablesDescriptionText: "Verilerinizi esnek ve özelleştirilebilir tablolarla yöneterek, filtreleme, sıralama ve gruplama gibi özelliklerle iş süreçlerinizi daha verimli ve analitik bir şekilde takip edebilirsiniz.",
        aiVoiceText: "Ai Sesli Asistan",
        aiVoiceDescriptionText: "Yapay Zeka Sesli Asistan, müşterilerinizi otomatik olarak arayarak randevu, sipariş ve taleplerini hızlı bir şekilde karşılar. Bu özellik, işletmenizin müşteri etkileşimlerini kolaylaştırır ve verimliliği artırır.",
        surveyIntroductionText: "Size daha iyi hizmet sunabilmemiz için birkaç sorumuz var.",
        sectorQuestionText: "Hangi sektörde faaliyet gösteriyorsunuz?",
        sectorPlaceholderText: "Sektörünüzü girin",
        departmentQuestionText: "Şirketinizde hangi birimde görev alıyorsunuz?",
        dropdownPlaceholderText: "Seçeneklerden seçin",
        salesOptionText: "Satış",
        supportOptionText: "Destek",
        itOptionText: "IT",
        softwareOptionText: "Yazılım",
        marketingOptionText: "Pazarlama",
        ceoOptionText: "CEO",
        founderOptionText: "Kurucu",
        managerOptionText: "Müdür",
        businessDevelopmentOptionText: "İş Geliştirme",
        designOptionText: "Tasarım",
        otherOptionText: "Diğer",
        otherSpecifyOptionText: "Diğer (belirtiniz)",
        heardAboutUsQuestionText: "Bizi nereden duydunuz?",
        youtubeOptionText: "YouTube",
        linkedInOptionText: "LinkedIn",
        socialMediaOptionText: "Sosyal Medya",
        emailMarketingOptionText: "E-posta Pazarlama",
        networkRecommendationOptionText: "Network & Çevrem Önerdi",
        googleSearchOptionText: "Google Araması",
        finalStepsText: "Sizin için en uygun paneli oluşturmak üzere son adımları tamamlıyoruz. Yapay zeka destekli iş uygulamalarıyla tüm iş süreçlerinizi tek bir ekrandan kolayca yönetmenin keyfini çıkarın.",
        greetingText: "Tanıştığımıza Çok Sevindik!",
        backLabel: "Geri Al",
        continueLabel: "Devam Et",
        completeSetupLabel: "Kurulumu Tamamla",
        technologySector: "Teknoloji",
        healthSector: "Sağlık",
        educationSector: "Eğitim",
        financeSector: "Finans",
        productionSector: "Üretim",
        retailSector: "Perakende",
        tourismSector: "Turizm",
        logisticsSector: "Lojistik",
        ecommerceSector: "E-Ticaret",
        mediaSector: "Medya",
        energySector: "Enerji",
        constructionSector: "İnşaat",
        agricultureSector: "Tarım",
        lawSector: "Hukuk",
        consultingSector: "Danışmanlık",
        foodSector: "Gıda",
        automotiveSector: "Otomotiv",
        sportsSector: "Spor",
    },
    en: {
        loginInformation: "Login Information",
        whatIsYourPurpose: "What Is Your Purpose?",
        addingASystem: "Adding a System",
        addingAModule: "Adding a Module",
        letsGetToKnowYou: "Let's Get to Know You",
        name: "Name",
        enterYourName: "Enter Your Name",
        surname: "Surname",
        enterYourLastName: "Enter Your Last Name",
        password: "Password",
        passwordRedial: "Password Redial",
        thePasswordMustComplyWithAllClauses: "The password must comply with all clauses:",
        number: "Number",
        eightToThirtyTwoCharacters: "8 to 32 characters",
        upperCase: "Uppercase",
        youCannotUseYourUsername: "You cannot use your username",
        namespaceIsRequired: "Namespace is required!",
        theSurnameFieldIsRequired: "The surname field is required!",
        RegisteredEmail: "Registered Email",
        siteName: "Site Name",
        welcomeMessage: "Welcome to Supsis AI",
        welcomeDescription: `I would like to meet you and offer you the most suitable solutions.<br>Please enter your name and edit your login information.`,
        aiExpectationsTitle: "What Are Your Expectations from Supsis AI Technology and Artificial Intelligence?",
        socialMediaManagementText: "Easily Manage All Social Media and Customer Communication on a Single Screen",
        aiChatbotAutomationText: "Automatically Manage Your Business 24/7 in Any Language with AI Chatbot",
        digitalSolutionsText: "Use effective digital solutions to help my brand reach a wider audience and increase its recognition.",
        optimizeProcessesText: "Optimize my business processes and manage my team more efficiently.",
        endToEndSolutionText: "Provide an end-to-end solution for my business without the need for human intervention.",
        aiTechnologyExperienceText: "Experience the Future Today with AI Technology!",
        multipleSystemsText: `You can select and try multiple systems.<br />Experience without any downloads.`,
        aiChatBotText: "AI ChatBot",
        aiChatbotManagementText: "Manage All Platforms and Requests End-to-End with No-Code AI Chatbot with Our Expert AI Team!",
        aiAssistantText: "AI Assistant",
        aiAssistantManagementText: "Easily manage all your business processes from any platform with AI assistant, and have a super assistant that provides uninterrupted support to you and your representatives.",
        aiLiveSupportText: "AI Live Support",
        aiLiveSupportManagementText: "Manage, analyze, and get detailed reports of all your social media and platforms from a single screen with AI-supported live support system.",
        aiAutomationText: "AI Automation",
        aiAutomationManagementText: "Integrate all your business scenarios, connect your processes, and manage your workflow automatically.",
        aiDynamicCrmText: "AI Dynamic CRM",
        aiDynamicCrmManagementText: "Manage your customer communication automatically and efficiently with dynamic CRM integrated with all modules and social media platforms.",
        customerInteractionChannelsText: "Which communication channels do you use to interact with your customers?",
        multipleSystemsSelectionText: `You can select and try multiple systems.<br>Experience without any downloads.`,
        platformsText: "Platforms",
        whatsappBusinessApiText: "WhatsApp Business API",
        whatsappWebText: "WhatsApp (Web)",
        instagramIntegrationText: "Instagram Integration",
        facebookIntegrationText: "Facebook Integration",
        telegramIntegrationText: "Telegram Integration",
        mailManagementSystemText: "Mail Management System",
        webChatText: "Web Chat",
        aiText: "Artificial Intelligence",
        metaLeadTrackingText: "Meta Lead Tracking",
        trendyolIntegrationText: "Trendyol Integration",
        linkedinIntegrationText: "LinkedIn Integration",
        manageYourBusinessModulesText: "Which Modules Do You Need to Manage Your Business?",
        allModulesAiChatbotAutomationText: `Use all modules, AI chatbot, automation, and <br> platforms fully integrated.`,
        modulesText: "Modules",
        formAndSurveyModuleText: "Form & Survey Module",
        analyzeCustomerBehaviorText: "Analyze customer behavior in depth with data integrated from all platforms to your website, understand their needs and expectations better, and develop special and effective strategies for them.",
        processAndTaskManagementModuleText: "Process & Task Management Module",
        manageBusinessProcessesText: "Set the conditions, priorities, and rules of your business processes, and easily plan, track, and manage your workflow with your team through all platforms and mobile applications.",
        videoAndAudioCallScreenSharingModuleText: "Video and Audio Call & Screen Sharing Module",
        webChatPlatformText: "Provide seamless and perfect interaction with your customers using all communication options such as instant messaging, file sharing, screen sharing, and automatic responses with the web chat platform.",
        calendarAndReservationSystemText: "Calendar & Reservation System",
        scheduleAppointmentsText: "Create appointments with your customers through all platforms, set reminders, and automatically organize your meetings even while you sleep with AI-supported chatbot.",
        webSiteAnalysisAndSegmentationText: "Website Analysis & Segmentation",
        analyzeWebsiteVisitorsText: "Analyze the visitors to your website in detail, determine which source they came from, which pages and products they are interested in, and help you get to know your target audience better by making detailed segmentation.",
        advertisingAnalysisAndReportingText: "Advertising Analysis & Reporting",
        analyzeVisitorsAndAdsText: "Segment the visitors to your website and social media ads in detail, analyze visitor behavior, automatically calculate the success and return rates of ads, and provide comprehensive reports.",
        ticketManagementSystemText: "Ticket Management System",
        manageTicketsText: "Respond to questions from all platforms offline at any time, collect requests from email, SMS, and WhatsApp in a single system, and easily manage them with the ticket system.",
        webPushAndPopupModuleText: "Web Push & Popup Module",
        webPushAndPopupModuleDescriptionText: "Segment visitors to your website and take dynamic actions based on their behavior, make cart reminders, and create triggers before they leave the website to increase engagement.",
        reMarketingCampaignsText: "Re-Marketing Campaigns",
        reMarketingCampaignsDescriptionText: "Instantly reach your customer base with bulk WhatsApp messages, email, and SMS system, send personalized messages to increase engagement, and easily manage all communication processes from a single platform.",
        dynamicTablesText: "Dynamic Tables",
        dynamicTablesDescriptionText: "Manage your data with flexible and customizable tables, and track your business processes more efficiently and analytically with features such as filtering, sorting, and grouping.",
        aiVoiceText: "AI Voice Assistant",
        aiVoiceDescriptionText: "The AI Voice Assistant automatically calls your customers to quickly handle appointments, orders, and requests. This feature simplifies customer interactions for your business and increases efficiency.",
        surveyIntroductionText: "We have a few questions to provide you with better service.",
        sectorQuestionText: "Which sector do you operate in?",
        sectorPlaceholderText: "Enter your sector",
        departmentQuestionText: "Which department do you work in at your company?",
        dropdownPlaceholderText: "Select options",
        salesOptionText: "Sales",
        supportOptionText: "Support",
        itOptionText: "IT",
        softwareOptionText: "Software",
        marketingOptionText: "Marketing",
        ceoOptionText: "CEO",
        founderOptionText: "Founder",
        managerOptionText: "Manager",
        businessDevelopmentOptionText: "Business Development",
        designOptionText: "Design",
        otherOptionText: "Other",
        otherSpecifyOptionText: "Other (specify)",
        heardAboutUsQuestionText: "Where did you hear about us?",
        youtubeOptionText: "YouTube",
        linkedInOptionText: "LinkedIn",
        socialMediaOptionText: "Social Media",
        emailMarketingOptionText: "Email Marketing",
        networkRecommendationOptionText: "Network & Friends Recommended",
        googleSearchOptionText: "Google Search",
        finalStepsText: "We are completing the final steps to create the most suitable panel for you. Enjoy managing all your business processes easily from a single screen with AI-supported business applications.",
        greetingText: "We Are Very Happy to Meet You!",
        backLabel: "Back",
        continueLabel: "Continue",
        completeSetupLabel: "Complete Setup",
        technologySector: "Technology",
        healthSector: "Health",
        educationSector: "Education",
        financeSector: "Finance",
        productionSector: "Production",
        retailSector: "Retail",
        tourismSector: "Tourism",
        logisticsSector: "Logistics",
        ecommerceSector: "E-Commerce",
        mediaSector: "Media",
        energySector: "Energy",
        constructionSector: "Construction",
        agricultureSector: "Agriculture",
        lawSector: "Law",
        consultingSector: "Consulting",
        foodSector: "Food",
        automotiveSector: "Automotive",
        sportsSector: "Sports",
    },
    ru: {
        loginInformation: "Информация для входа",
        whatIsYourPurpose: "Какова ваша цель?",
        addingASystem: "Добавление системы",
        addingAModule: "Добавление модуля",
        letsGetToKnowYou: "Давайте познакомимся",
        name: "Имя",
        enterYourName: "Введите ваше имя",
        surname: "Фамилия",
        enterYourLastName: "Введите вашу фамилию",
        password: "Пароль",
        passwordRedial: "Повтор пароля",
        thePasswordMustComplyWithAllClauses: "Пароль должен соответствовать всем пунктам:",
        number: "Номер",
        eightToThirtyTwoCharacters: "От 8 до 32 символов",
        upperCase: "Заглавная буква",
        youCannotUseYourUsername: "Вы не можете использовать ваше имя пользователя",
        namespaceIsRequired: "Требуется пространство имен!",
        theSurnameFieldIsRequired: "Поле фамилии обязательно!",
        RegisteredEmail: "Зарегистрированный Email",
        siteName: "Название сайта",
        welcomeMessage: "Добр�� пожаловать в Supsis AI",
        welcomeDescription: `Я хотел бы познакомиться с вами и предложить вам наиболее подходящие решения.<br>Пожалуйста, введите ваше имя и отредактируйте информацию для входа.`,
        aiExpectationsTitle: "Каковы ваши ожидания от технологии Supsis AI и искусственного интеллекта?",
        socialMediaManagementText: "Легко управляйте всеми социальными сетями и общением с клиентами на одном экране",
        aiChatbotAutomationText: "Автоматически управляйте своим бизнесом 24/7 на любом языке с помощью AI Chatbot",
        digitalSolutionsText: "Используйте эффективные цифровые решения, чтобы помочь моему бренду достичь более широкой аудитории и повысить его узнаваемость.",
        optimizeProcessesText: "Оптимизируйте мои бизнес-процессы и управляй��е моей командой более эффективно.",
        endToEndSolutionText: "Предоставьте комплексное решение для моего бизнеса без необходимости вмешательства человека.",
        aiTechnologyExperienceText: "Испытайте будущее сегодня с технологией AI!",
        multipleSystemsText: `Вы можете выбрать и попробовать несколько систем.<br />Испытайте без каких-либо загрузок.`,
        aiChatBotText: "AI ChatBot",
        aiChatbotManagementText: "Управляйте всеми платформами и запросами от начала до конца с помощью No-Code AI Chatbot с нашей экспертной командой AI!",
        aiAssistantText: "AI Ассистент",
        aiAssistantManagementText: "Легко управляйте всеми вашими бизнес-процессами с любой платформы с помощь�� AI ассистента и имейте супер ассистента, который предоставляет непрерывную поддержку вам и вашим представителям.",
        aiLiveSupportText: "AI Живая поддержка",
        aiLiveSupportManagementText: "Управляйте, анализируйте и получайте подробные отчеты по всем вашим социальным сетям и платформам с одного экрана с помощью системы живой поддержки на базе AI.",
        aiAutomationText: "AI Автоматизация",
        aiAutomationManagementText: "Интегрируйте все ваши бизнес-сценарии, соединяйте ваши процессы и управляйте вашим рабочим процессом автоматически.",
        aiDynamicCrmText: "AI Динамическая CRM",
        aiDynamicCrmManagementText: "Управляйте общением с клиентами автоматически и эффективно с помощью динамической CRM, интегрированной со всеми модулями и социальными с��тями.",
        customerInteractionChannelsText: "Какие каналы связи вы используете для взаимодействия с вашими клиентами?",
        multipleSystemsSelectionText: `Вы можете выбрать и попробовать несколько систем.<br>Испытайте без каких-либо загрузок.`,
        platformsText: "Пл��тформы",
        whatsappBusinessApiText: "WhatsApp Business API",
        whatsappWebText: "WhatsApp (Web)",
        instagramIntegrationText: "Интеграция с Instagram",
        facebookIntegrationText: "Интеграция с Facebook",
        telegramIntegrationText: "Интеграция с Telegram",
        mailManagementSystemText: "Система управления почтой",
        webChatText: "Веб-чат",
        aiText: "Искусственный интеллект",
        metaLeadTrackingText: "Отслеживание лидов Meta",
        trendyolIntegrationText: "Интеграция с Trendyol",
        linkedinIntegrationText: "Интеграция с LinkedIn",
        manageYourBusinessModulesText: "Какие модули вам нужны для управления вашим бизнесом?",
        allModulesAiChatbotAutomationText: `Используйте все модули, AI chatbot, автоматизацию и <br> платформы в полной интеграции.`,
        modulesText: "Модули",
        formAndSurveyModuleText: "Модуль форм и опросов",
        analyzeCustomerBehaviorText: "Анализируйте поведение клиентов в глубину с данными, интегрированными со всех платформ на ваш сайт, лучше понимайте их потребности и ожидания и разрабатывайте для них специальные и эффективные стратегии.",
        processAndTaskManagementModuleText: "Модуль управления процессами и задачами",
        manageBusinessProcessesText: "Устанавливайте условия, приоритеты и правила ваших бизнес-процессов и легко планируйте, отслеживайте и управляйте вашим рабочим процессом с вашей командой через все платформы и мобильные приложения.",
        videoAndAudioCallScreenSharingModuleText: "Модуль видеозвонков и аудиозвонков и совместного использования экрана",
        webChatPlatformText: "Обеспечьте беспрерывное и идеальное взаимодействие с вашими клиентам��, используя все возможности общения, такие как мгновенные сообщения, обмен файлами, совместное использование экрана и автоматические ответы с помощью веб-чат платформы.",
        calendarAndReservationSystemText: "Система календаря и бронирования",
        scheduleAppointmentsText: "Создавайте встречи с вашими клиентами через все платформы, устанавливайте напоминания и автоматически организуйте ваши встречи даже во время сна с помощью чатбота на базе AI.",
        webSiteAnalysisAndSegmentationText: "Анализ и сегментация веб-сайта",
        analyzeWebsiteVisitorsText: "Анализируйте посетителей вашего веб-сайта в деталях, определяйте, из какого источника они пришли, какие страницы и продукты их интересуют, и помогайте вам лучше узнать вашу целевую аудиторию, проводя детальную сегментацию.",
        advertisingAnalysisAndReportingText: "Анализ и отчетность по рекламе",
        analyzeVisitorsAndAdsText: "Сегментируйте посетителей вашего веб-сайта и социальных сетей в деталях, анализируйте поведение посетителей, автоматически рассчитывайте успех и коэффициенты возврата рекламы и предоставляйте комплексные отчеты.",
        ticketManagementSystemText: "Система управления тикетами",
        manageTicketsText: "Отвечайте на вопросы со всех платформ в любое время офлайн, собирайте запросы из электронной почты, SMS и WhatsApp в одной системе и легко управляйте ими с помощью системы тикетов.",
        webPushAndPopupModuleText: "Модуль веб-пушей и всплывающих окон",
        webPushAndPopupModuleDescriptionText: "Сегментируйте посетителей вашего веб-сайта и принимайте динамические действия на основе их поведения, делайте напоминания о корзине и создавайте триггеры перед тем, как они покинут сайт, чтобы увеличить вовлеченность.",
        reMarketingCampaignsText: "Кампании ремаркетинга",
        reMarketingCampaignsDescriptionText: "Мгновенно достигайте вашей клиентской базы с помощью массовых сообщений WhatsApp, электронной почты и SMS, отправляйте персонализированные сообщения для увеличения вовлеченности и легко управляйте всеми процессами общения с одной платформы.",
        dynamicTablesText: "Динамические таблицы",
        dynamicTablesDescriptionText: "Управляйте вашими данными с помощью гибких и настраиваемых таблиц и отслеживайте ваши б��знес-процессы более эффективно и аналитически с такими функциями, как фильтрация, сортировка и группировка.",
        aiVoiceText: "AI Голосовой Ассистент",
        aiVoiceDescriptionText: "Искусственный интеллект Голосовой Ассистент автоматически звонит вашим клиентам, чтобы быстро обработать встречи, заказы и запросы. Эта функция упрощает взаимодействие с клиентами для вашего бизнеса и повышает эффективность.",
        surveyIntroductionText: "У нас есть несколько вопросов, чтобы предоставить вам лучший сервис.",
        sectorQuestionText: "В какой отрасли вы работаете?",
        sectorPlaceholderText: "Введите вашу отрасль",
        departmentQuestionText: "В каком отделе вы работаете в вашей компании?",
        dropdownPlaceholderText: "Выберите из вариантов",
        salesOptionText: "Продажи",
        supportOptionText: "Поддержка",
        itOptionText: "IT",
        softwareOptionText: "Программное обеспечение",
        marketingOptionText: "Маркетинг",
        ceoOptionText: "CEO",
        founderOptionText: "Основатель",
        managerOptionText: "Менеджер",
        businessDevelopmentOptionText: "Развитие бизнеса",
        designOptionText: "Дизайн",
        otherOptionText: "Другое",
        otherSpecifyOptionText: "Другое (уточните)",
        heardAboutUsQuestionText: "Где вы о нас узнали?",
        youtubeOptionText: "YouTube",
        linkedInOptionText: "LinkedIn",
        socialMediaOptionText: "Социальные сети",
        emailMarketingOptionText: "Email маркетинг",
        networkRecommendationOptionText: "Рекомендация сети и друзей",
        googleSearchOptionText: "Поиск в Google",
        finalStepsText: "Мы завершаем последние шаги по созданию наиболее подходящей панели для вас. Наслаждайтесь управлением всеми вашими бизнес-процессами легко с одного экрана с по��ощью бизнес-приложений на базе AI.",
        greetingText: "Мы очень рады познакомиться с вами!",
        backLabel: "Назад",
        continueLabel: "Продолжить",
        completeSetupLabel: "Завершить настройку",
        technologySector: "Технологии",
        healthSector: "Здравоохранение",
        educationSector: "Образование",
        financeSector: "Финансы",
        productionSector: "Производство",
        retailSector: "Розничная торговля",
        tourismSector: "Туризм",
        logisticsSector: "Логистика",
        ecommerceSector: "Электронная коммерция",
        mediaSector: "Медиа",
        energySector: "Энергетика",
        constructionSector: "Строительство",
        agricultureSector: "Сельское хозяйство",
        lawSector: "Право",
        consultingSector: "Консалтинг",
        foodSector: "Пищевая промышленность",
        automotiveSector: "Автомобильная промышленность",
        sportsSector: "Спорт",
    },
    de: {
        loginInformation: "Anmeldeinformationen",
        whatIsYourPurpose: "Was ist Ihr Zweck?",
        addingASystem: "System hinzufügen",
        addingAModule: "Modul hinzufügen",
        letsGetToKnowYou: "Lassen Sie uns Sie kennenlernen",
        name: "Name",
        enterYourName: "Geben Sie Ihren Namen ein",
        surname: "Nachname",
        enterYourLastName: "Geben Sie Ihren Nachnamen ein",
        password: "Passwort",
        passwordRedial: "Passwort erneut eingeben",
        thePasswordMustComplyWithAllClauses: "Das Passwort muss allen Klauseln entsprechen:",
        number: "Nummer",
        eightToThirtyTwoCharacters: "8 bis 32 Zeichen",
        upperCase: "Großbuchstaben",
        youCannotUseYourUsername: "Sie können Ihren Benutzernamen nicht verwenden",
        namespaceIsRequired: "Namensraum ist erforderlich!",
        theSurnameFieldIsRequired: "Das Nachname-Feld ist erforderlich!",
        RegisteredEmail: "Registrierte E-Mail",
        siteName: "Seitenname",
        welcomeMessage: "Willkommen bei Supsis AI",
        welcomeDescription: `Ich möchte Sie kennenlernen und Ihnen die am besten geeigneten Lösungen anbieten.<br>Bitte geben Sie Ihren Namen ein und bearbeiten Sie Ihre Anmeldeinformationen.`,
        aiExpectationsTitle: "Was sind Ihre Erwartungen an die Supsis AI-Technologie und künstliche Intelligenz?",
        socialMediaManagementText: "Verwalten Sie alle sozialen Medien und die Kundenkommunikation einfach auf einem Bildschirm",
        aiChatbotAutomationText: "Verwalten Sie Ihr Geschäft automatisch 24/7 in jeder Sprache mit dem AI-Chatbot",
        digitalSolutionsText: "Verwenden Sie effektive digitale Lösungen, um meiner Marke zu helfen, ein breiteres Publikum zu erreichen und ihre Bekanntheit zu steigern.",
        optimizeProcessesText: "Optimieren Sie meine Geschäftsprozesse und verwalten Sie mein Team effizienter.",
        endToEndSolutionText: "Bieten Sie eine End-to-End-Lösung für mein Unternehmen ohne menschliches Eingreifen.",
        aiTechnologyExperienceText: "Erleben Sie die Zukunft heute mit AI-Technologie!",
        multipleSystemsText: `Sie können mehrere Systeme auswählen und ausprobieren.<br />Erleben Sie es ohne Downloads.`,
        aiChatBotText: "AI-Chatbot",
        aiChatbotManagementText: "Verwalten Sie alle Plattformen und Anfragen End-to-End mit dem No-Code AI-Chatbot mit unserem Expertenteam!",
        aiAssistantText: "AI-Assistent",
        aiAssistantManagementText: "Verwalten Sie alle Ihre Geschäftsprozesse einfach von jeder Plattform aus mit dem AI-Assistenten und haben Sie einen Super-Assistenten, der Ihnen und Ihren Vertretern ununterbrochene Unterstützung bietet.",
        aiLiveSupportText: "AI-Live-Support",
        aiLiveSupportManagementText: "Verwalten, analysieren und erhalten Sie detaillierte Berichte über alle Ihre sozialen Medien und Plattformen von einem einzigen Bildschirm mit dem AI-unterstützten Live-Support-System.",
        aiAutomationText: "AI-Automatisierung",
        aiAutomationManagementText: "Integrieren Sie alle Ihre Geschäftsszenarien, verbinden Sie Ihre Prozesse und verwalten Sie Ihren Arbeitsablauf automatisch.",
        aiDynamicCrmText: "AI-Dynamisches CRM",
        aiDynamicCrmManagementText: "Verwalten Sie Ihre Kundenkommunikation automatisch und effizient mit dem dynamischen CRM, das in alle Module und sozialen Medien integriert ist.",
        customerInteractionChannelsText: "Welche Kommunikationskanäle verwenden Sie, um mit Ihren Kunden zu interagieren?",
        multipleSystemsSelectionText: `Sie können mehrere Systeme auswählen und ausprobieren.<br>Erleben Sie es ohne Downloads.`,
        platformsText: "Plattformen",
        whatsappBusinessApiText: "WhatsApp Business API",
        whatsappWebText: "WhatsApp (Web)",
        instagramIntegrationText: "Instagram-Integration",
        facebookIntegrationText: "Facebook-Integration",
        telegramIntegrationText: "Telegram-Integration",
        mailManagementSystemText: "E-Mail-Management-System",
        webChatText: "Web-Chat",
        aiText: "Künstliche Intelligenz",
        metaLeadTrackingText: "Meta-Lead-Tracking",
        trendyolIntegrationText: "Trendyol-Integration",
        linkedinIntegrationText: "LinkedIn Integration",
        manageYourBusinessModulesText: "Welche Module benötigen Sie, um Ihr Geschäft zu verwalten?",
        allModulesAiChatbotAutomationText: `Verwenden Sie alle Module, AI-Chatbot, Automatisierung und <br> Plattformen vollständig integriert.`,
        modulesText: "Module",
        formAndSurveyModuleText: "Formular- und Umfragemodul",
        analyzeCustomerBehaviorText: "Analysieren Sie das Kundenverhalten in der Tiefe mit Daten, die von allen Plattformen in Ihre Website integriert sind, verstehen Sie ihre Bedürfnisse und Erwartungen besser und entwickeln Sie spezielle und effektive Strategien für sie.",
        processAndTaskManagementModuleText: "Prozess- und Aufgabenmanagement-Modul",
        manageBusinessProcessesText: "Legen Sie die Bedingungen, Prioritäten und Regeln Ihrer Geschäftsprozesse fest und planen, verfolgen und verwalten Sie Ihren Arbeitsablauf einfach mit Ihrem Team über alle Plattformen und mobilen Anwendungen.",
        videoAndAudioCallScreenSharingModuleText: "Video- und Audioanruf- & Bildschirmfreigabe-Modul",
        webChatPlatformText: "Bieten Sie nahtlose und perfekte Interaktion mit Ihren Kunden, indem Sie alle Kommunikationsoptionen wie Sofortnachrichten, Dateifreigabe, Bildschirmfreigabe und automatische Antworten mit der Web-Chat-Plattform nutzen.",
        calendarAndReservationSystemText: "Kalender- & Reservierungssystem",
        scheduleAppointmentsText: "Erstellen Sie Termine mit Ihren Kunden über alle Plattformen, richten Sie Erinnerungen ein und organisieren Sie Ihre Meetings automatisch, auch während Sie schlafen, mit dem AI-unterstützten Chatbot.",
        webSiteAnalysisAndSegmentationText: "Website-Analyse & Segmentierung",
        analyzeWebsiteVisitorsText: "Analysieren Sie die Besucher Ihrer Website im Detail, bestimmen Sie, aus welcher Quelle sie gekommen sind, welche Seiten und Produkte sie interessieren, und helfen Sie Ihnen, Ihre Zielgruppe besser kennenzulernen, indem Sie eine detaillierte Segmentierung vornehmen.",
        advertisingAnalysisAndReportingText: "Werbeanalyse & Berichterstattung",
        analyzeVisitorsAndAdsText: "Segmentieren Sie die Besucher Ihrer Website und sozialen Medien im Detail, analysieren Sie das Besucherverhalten, berechnen Sie automatisch den Erfolg und die Rücklaufquoten von Anzeigen und bieten Sie umfassende Berichte.",
        ticketManagementSystemText: "Ticket-Management-System",
        manageTicketsText: "Beantworten Sie Fragen von allen Plattformen offline zu jeder Zeit, sammeln Sie Anfragen aus E-Mail, SMS und WhatsApp in einem einzigen System und verwalten Sie sie einfach mit dem Ticket-System.",
        webPushAndPopupModuleText: "Web-Push- & Popup-Modul",
        webPushAndPopupModuleDescriptionText: "Segmentieren Sie die Besucher Ihrer Website und ergreifen Sie dynamische Maßnahmen basierend auf ihrem Verhalten, machen Sie Warenkorberinnerungen und erstellen Sie Trigger, bevor sie die Website verlassen, um das Engagement zu erhöhen.",
        reMarketingCampaignsText: "Re-Marketing-Kampagnen",
        reMarketingCampaignsDescriptionText: "Erreichen Sie Ihre Kundenbasis sofort mit Massen-WhatsApp-Nachrichten, E-Mail- und SMS-System, senden Sie personalisierte Nachrichten, um das Engagement zu erhöhen, und verwalten Sie alle Kommunikationsprozesse einfach von einer einzigen Plattform aus.",
        dynamicTablesText: "Dynamische Tabellen",
        dynamicTablesDescriptionText: "Verwalten Sie Ihre Daten mit flexiblen und anpassbaren Tabellen und verfolgen Sie Ihre Geschäftsprozesse effizienter und analytischer mit Funktionen wie Filtern, Sortieren und Gruppieren.",
        aiVoiceText: "AI Sprachassistent",
        aiVoiceDescriptionText: "Der KI-Sprachassistent ruft Ihre Kunden automatisch an, um Termine, Bestellungen und Anfragen schnell zu bearbeiten. Diese Funktion vereinfacht die Kundeninteraktionen für Ihr Unternehmen und steigert die Effizienz.",
        surveyIntroductionText: "Wir haben ein paar Fragen, um Ihnen einen besseren Service zu bieten.",
        sectorQuestionText: "In welcher Branche sind Sie tätig?",
        sectorPlaceholderText: "Geben Sie Ihre Branche ein",
        departmentQuestionText: "In welcher Abteilung arbeiten Sie in Ihrem Unternehmen?",
        dropdownPlaceholderText: "Wählen Sie aus den Optionen",
        salesOptionText: "Vertrieb",
        supportOptionText: "Support",
        itOptionText: "IT",
        softwareOptionText: "Software",
        marketingOptionText: "Marketing",
        ceoOptionText: "CEO",
        founderOptionText: "Gründer",
        managerOptionText: "Manager",
        businessDevelopmentOptionText: "Geschäftsentwicklung",
        designOptionText: "Design",
        otherOptionText: "Andere",
        otherSpecifyOptionText: "Andere (spezifizieren)",
        heardAboutUsQuestionText: "Wo haben Sie von uns gehört?",
        youtubeOptionText: "YouTube",
        linkedInOptionText: "LinkedIn",
        socialMediaOptionText: "Soziale Medien",
        emailMarketingOptionText: "E-Mail-Marketing",
        networkRecommendationOptionText: "Netzwerk- & Freundesempfehlung",
        googleSearchOptionText: "Google-Suche",
        finalStepsText: "Wir schließen die letzten Schritte ab, um das am besten geeignete Panel für Sie zu erstellen. Genießen Sie es, alle Ihre Geschäftsprozesse einfach von einem einzigen Bildschirm aus mit AI-unterstützten Geschäftsanwendungen zu verwalten.",
        greetingText: "Wir freuen uns sehr, Sie kennenzulernen!",
        backLabel: "Zurück",
        continueLabel: "Weiter",
        completeSetupLabel: "Setup abschließen",
        technologySector: "Technologie",
        healthSector: "Gesundheit",
        educationSector: "Bildung",
        financeSector: "Finanzen",
        productionSector: "Produktion",
        retailSector: "Einzelhandel",
        tourismSector: "Tourismus",
        logisticsSector: "Logistik",
        ecommerceSector: "E-Commerce",
        mediaSector: "Medien",
        energySector: "Energie",
        constructionSector: "Bauwesen",
        agricultureSector: "Landwirtschaft",
        lawSector: "Recht",
        consultingSector: "Beratung",
        foodSector: "Lebensmittel",
        automotiveSector: "Automobilindustrie",
        sportsSector: "Sport",
    },
    fr: {
        loginInformation: "Informations de connexion",
        whatIsYourPurpose: "Quel est votre objectif?",
        addingASystem: "Ajout d'un système",
        addingAModule: "Ajout d'un module",
        letsGetToKnowYou: "Faisons connaissance",
        name: "Nom",
        enterYourName: "Entrez votre nom",
        surname: "Prénom",
        enterYourLastName: "Entrez votre prénom",
        password: "Mot de passe",
        passwordRedial: "Répétez le mot de passe",
        thePasswordMustComplyWithAllClauses: "Le mot de passe doit respecter toutes les clauses:",
        number: "Numéro",
        eightToThirtyTwoCharacters: "8 à 32 caractères",
        upperCase: "Majuscule",
        youCannotUseYourUsername: "Vous ne pouvez pas utiliser votre nom d'utilisateur",
        namespaceIsRequired: "L'espace de noms est requis!",
        theSurnameFieldIsRequired: "Le champ prénom est requis!",
        RegisteredEmail: "Email enregistré",
        siteName: "Nom du site",
        welcomeMessage: "Bienvenue chez Supsis AI",
        welcomeDescription: `Je voudrais vous rencontrer et vous proposer les solutions les plus adaptées.<br>Veuillez entrer votre nom et modifier vos informations de connexion.`,
        aiExpectationsTitle: "Quelles sont vos attentes vis-à-vis de la technologie Supsis AI et de l'intelligence artificielle?",
        socialMediaManagementText: "Gérez facilement tous les réseaux sociaux et la communication client sur un seul écran",
        aiChatbotAutomationText: "Gérez automatiquement votre entreprise 24/7 dans n'importe quelle langue avec le chatbot AI",
        digitalSolutionsText: "Utilisez des solutions numériques efficaces pour aider ma marque à atteindre un public plus large et à accroître sa reconnaissance.",
        optimizeProcessesText: "Optimisez mes processus métier et gérez mon équipe plus efficacement.",
        endToEndSolutionText: "Fournissez une solution de bout en bout pour mon entreprise sans intervention humaine.",
        aiTechnologyExperienceText: "Vivez le futur aujourd'hui avec la technologie AI!",
        multipleSystemsText: `Vous pouvez sélectionner et essayer plusieurs systèmes.<br />Expérience sans aucun téléchargement.`,
        aiChatBotText: "Chatbot AI",
        aiChatbotManagementText: "Gérez toutes les plateformes et demandes de bout en bout avec le chatbot AI sans code avec notre équipe d'experts AI!",
        aiAssistantText: "Assistant AI",
        aiAssistantManagementText: "Gérez facilement tous vos processus métier depuis n'importe quelle plateforme avec l'assistant AI, et disposez d'un super assistant qui fournit un support ininterrompu à vous et à vos représentants.",
        aiLiveSupportText: "Support en direct AI",
        aiLiveSupportManagementText: "Gérez, analysez et obtenez des rapports détaillés de tous vos réseaux sociaux et plateformes depuis un seul écran avec le système de support en direct AI.",
        aiAutomationText: "Automatisation AI",
        aiAutomationManagementText: "Intégrez tous vos scénarios métier, connectez vos processus et gérez votre flux de travail automatiquement.",
        aiDynamicCrmText: "CRM dynamique AI",
        aiDynamicCrmManagementText: "Gérez automatiquement et efficacement votre communication client avec le CRM dynamique intégré à tous les modules et réseaux sociaux.",
        customerInteractionChannelsText: "Quels canaux de communication utilisez-vous pour interagir avec vos clients?",
        multipleSystemsSelectionText: `Vous pouvez sélectionner et essayer plusieurs systèmes.<br>Expérience sans aucun téléchargement.`,
        platformsText: "Plateformes",
        whatsappBusinessApiText: "API WhatsApp Business",
        whatsappWebText: "WhatsApp (Web)",
        instagramIntegrationText: "Intégration Instagram",
        facebookIntegrationText: "Intégration Facebook",
        telegramIntegrationText: "Intégration Telegram",
        mailManagementSystemText: "Système de gestion des mails",
        webChatText: "Chat Web",
        aiText: "Intelligence Artificielle",
        metaLeadTrackingText: "Suivi des leads Meta",
        trendyolIntegrationText: "Intégration Trendyol",
        linkedinIntegrationText: "Intégration LinkedIn",
        manageYourBusinessModulesText: "Quels modules avez-vous besoin pour gérer votre entreprise?",
        allModulesAiChatbotAutomationText: `Utilisez tous les modules, chatbot AI, automatisation et <br> plateformes entièrement intégrés.`,
        modulesText: "Modules",
        formAndSurveyModuleText: "Module de formulaires et enquêtes",
        analyzeCustomerBehaviorText: "Analysez en profondeur le comportement des clients avec des données intégrées de toutes les plateformes à votre site web, comprenez mieux leurs besoins et attentes, et développez des stratégies spéciales et efficaces pour eux.",
        processAndTaskManagementModuleText: "Module de gestion des processus et des tâches",
        manageBusinessProcessesText: "Définissez les conditions, priorités et règles de vos processus métier, et planifiez, suivez et gérez facilement votre flux de travail avec votre équipe sur toutes les plateformes et applications mobiles.",
        videoAndAudioCallScreenSharingModuleText: "Module d'appels vidéo et audio et de partage d'écran",
        webChatPlatformText: "Offrez une interaction fluide et parfaite avec vos clients en utilisant toutes les options de communication telles que la messagerie instantanée, le partage de fichiers, le partage d'écran et les réponses automatiques avec la plateforme de chat web.",
        calendarAndReservationSystemText: "Système de calendrier et de réservation",
        scheduleAppointmentsText: "Créez des rendez-vous avec vos clients sur toutes les plateformes, définissez des rappels et organisez automatiquement vos réunions même pendant votre sommeil avec le chatbot AI.",
        webSiteAnalysisAndSegmentationText: "Analyse et segmentation du site web",
        analyzeWebsiteVisitorsText: "Analysez en détail les visiteurs de votre site web, déterminez de quelle source ils proviennent, quelles pages et produits les intéressent, et aidez-vous à mieux connaître votre public cible en effectuant une segmentation détaillée.",
        advertisingAnalysisAndReportingText: "Analyse et reporting publicitaire",
        analyzeVisitorsAndAdsText: "Segmentez en détail les visiteurs de votre site web et des publicités sur les réseaux sociaux, analysez le comportement des visiteurs, calculez automatiquement le succès et les taux de retour des publicités, et fournissez des rapports complets.",
        ticketManagementSystemText: "Système de gestion des tickets",
        manageTicketsText: "Répondez aux questions de toutes les plateformes hors ligne à tout moment, collectez les demandes par email, SMS et WhatsApp dans un seul système et gérez-les facilement avec le système de tickets.",
        webPushAndPopupModuleText: "Module de notifications push et pop-up web",
        webPushAndPopupModuleDescriptionText: "Segmentez les visiteurs de votre site web et prenez des actions dynamiques en fonction de leur comportement, faites des rappels de panier et créez des déclencheurs avant qu'ils ne quittent le site pour augmenter l'engagement.",
        reMarketingCampaignsText: "Campagnes de remarketing",
        reMarketingCampaignsDescriptionText: "Atteignez instantanément votre base de clients avec des messages WhatsApp en masse, des emails et des SMS, envoyez des messages personnalisés pour augmenter l'engagement et gérez facilement tous les processus de communication depuis une seule plateforme.",
        dynamicTablesText: "Tableaux dynamiques",
        dynamicTablesDescriptionText: "Gérez vos données avec des tableaux flexibles et personnalisables, et suivez vos processus métier de manière plus efficace et analytique avec des fonctionnalités telles que le filtrage, le tri et le regroupement.",
        surveyIntroductionText: "Nous avons quelques questions pour vous offrir un meilleur service.",
        sectorQuestionText: "Dans quel secteur opérez-vous?",
        sectorPlaceholderText: "Entrez votre secteur",
        departmentQuestionText: "Dans quel département travaillez-vous dans votre entreprise?",
        dropdownPlaceholderText: "Sélectionnez les options",
        salesOptionText: "Ventes",
        supportOptionText: "Support",
        itOptionText: "IT",
        softwareOptionText: "Logiciel",
        marketingOptionText: "Marketing",
        ceoOptionText: "CEO",
        founderOptionText: "Fondateur",
        managerOptionText: "Manager",
        businessDevelopmentOptionText: "Développement commercial",
        designOptionText: "Design",
        otherOptionText: "Autre",
        otherSpecifyOptionText: "Autre (précisez)",
        heardAboutUsQuestionText: "Où avez-vous entendu parler de nous?",
        youtubeOptionText: "YouTube",
        linkedInOptionText: "LinkedIn",
        socialMediaOptionText: "Réseaux sociaux",
        emailMarketingOptionText: "Email marketing",
        networkRecommendationOptionText: "Recommandation de réseau et d'amis",
        googleSearchOptionText: "Recherche Google",
        finalStepsText: "Nous terminons les dernières étapes pour créer le panneau le plus adapté pour vous. Profitez de la gestion de tous vos processus métier facilement depuis un seul écran avec des applications métier soutenues par l'IA.",
        greetingText: "Nous sommes très heureux de vous rencontrer!",
        backLabel: "Retour",
        continueLabel: "Continuer",
        completeSetupLabel: "Terminer la configuration",
        technologySector: "Technologie",
        healthSector: "Santé",
        educationSector: "Éducation",
        financeSector: "Finance",
        productionSector: "Production",
        retailSector: "Vente au détail",
        tourismSector: "Tourisme",
        logisticsSector: "Logistique",
        ecommerceSector: "E-Commerce",
        mediaSector: "Médias",
        energySector: "Énergie",
        constructionSector: "Construction",
        agricultureSector: "Agriculture",
        lawSector: "Droit",
        consultingSector: "Conseil",
        foodSector: "Alimentation",
        automotiveSector: "Industrie automobile",
        sportsSector: "Sport",
    },
    es: {
        loginInformation: "Información de inicio de sesión",
        whatIsYourPurpose: "¿Cuál es tu propósito?",
        addingASystem: "Añadiendo un sistema",
        addingAModule: "Añadiendo un módulo",
        letsGetToKnowYou: "Conozcámonos",
        name: "Nombre",
        enterYourName: "Introduce tu nombre",
        surname: "Apellido",
        enterYourLastName: "Introduce tu apellido",
        password: "Contraseña",
        passwordRedial: "Repetir contraseña",
        thePasswordMustComplyWithAllClauses: "La contraseña debe cumplir con todas las cláusulas:",
        number: "Número",
        eightToThirtyTwoCharacters: "De 8 a 32 caracteres",
        upperCase: "Mayúscula",
        youCannotUseYourUsername: "No puedes usar tu nombre de usuario",
        namespaceIsRequired: "¡El espacio de nombres es obligatorio!",
        theSurnameFieldIsRequired: "¡El campo de apellido es obligatorio!",
        RegisteredEmail: "Correo electrónico registrado",
        siteName: "Nombre del sitio",
        welcomeMessage: "Bienvenido a Supsis AI",
        welcomeDescription: `Me gustaría conocerte y ofrecerte las soluciones más adecuadas.<br>Por favor, introduce tu nombre y edita tu información de inicio de sesión.`,
        aiExpectationsTitle: "¿Cuáles son tus expectativas de la tecnología Supsis AI y la inteligencia artificial?",
        socialMediaManagementText: "Gestiona fácilmente todas las redes sociales y la comunicación con los clientes en una sola pantalla",
        aiChatbotAutomationText: "Gestiona automáticamente tu negocio 24/7 en cualquier idioma con el chatbot AI",
        digitalSolutionsText: "Utiliza soluciones digitales efectivas para ayudar a mi marca a llegar a una audiencia más amplia y aumentar su reconocimiento.",
        optimizeProcessesText: "Optimiza mis procesos empresariales y gestiona mi equipo de manera más eficiente.",
        endToEndSolutionText: "Proporciona una solución integral para mi negocio sin necesidad de intervención humana.",
        aiTechnologyExperienceText: "¡Experimenta el futuro hoy con la tecnología AI!",
        multipleSystemsText: `Puedes seleccionar y probar múltiples sistemas.<br />Experimenta sin ninguna descarga.`,
        aiChatBotText: "ChatBot AI",
        aiChatbotManagementText: "Gestiona todas las plataformas y solicitudes de principio a fin con el chatbot AI sin código con nuestro equipo de expertos en AI.",
        aiAssistantText: "Asistente AI",
        aiAssistantManagementText: "Gestiona fácilmente todos tus procesos empresariales desde cualquier plataforma con el asistente AI, y ten un super asistente que proporciona soporte ininterrumpido a ti y a tus representantes.",
        aiLiveSupportText: "Soporte en vivo AI",
        aiLiveSupportManagementText: "Gestiona, analiza y obtén informes detallados de todas tus redes sociales y plataformas desde una sola pantalla con el sistema de soporte en vivo AI.",
        aiAutomationText: "Automatización AI",
        aiAutomationManagementText: "Integra todos tus escenarios empresariales, conecta tus procesos y gestiona tu flujo de trabajo automáticamente.",
        aiDynamicCrmText: "CRM dinámico AI",
        aiDynamicCrmManagementText: "Gestiona tu comunicación con los clientes de manera automática y eficiente con el CRM dinámico integrado con todos los módulos y plataformas de redes sociales.",
        customerInteractionChannelsText: "¿Qué canales de comunicación utilizas para interactuar con tus clientes?",
        multipleSystemsSelectionText: `Puedes seleccionar y probar múltiples sistemas.<br>Experimenta sin ninguna descarga.`,
        platformsText: "Plataformas",
        whatsappBusinessApiText: "API de WhatsApp Business",
        whatsappWebText: "WhatsApp (Web)",
        instagramIntegrationText: "Integración con Instagram",
        facebookIntegrationText: "Integración con Facebook",
        telegramIntegrationText: "Integración con Telegram",
        mailManagementSystemText: "Sistema de gestión de correos",
        webChatText: "Chat web",
        aiText: "Inteligencia Artificial",
        metaLeadTrackingText: "Seguimiento de leads de Meta",
        trendyolIntegrationText: "Integración con Trendyol",
        linkedinIntegrationText: "Integración con LinkedIn",
        manageYourBusinessModulesText: "¿Qué módulos necesitas para gestionar tu negocio?",
        allModulesAiChatbotAutomationText: `Utiliza todos los módulos, chatbot AI, automatización y <br> plataformas totalmente integradas.`,
        modulesText: "Módulos",
        formAndSurveyModuleText: "Módulo de formularios y encuestas",
        analyzeCustomerBehaviorText: "Analiza en profundidad el comportamiento de los clientes con datos integrados de todas las plataformas a tu sitio web, comprende mejor sus necesidades y expectativas, y desarrolla estrategias especiales y efectivas para ellos.",
        processAndTaskManagementModuleText: "Módulo de gestión de procesos y tareas",
        manageBusinessProcessesText: "Establece las condiciones, prioridades y reglas de tus procesos empresariales, y planifica, sigue y gestiona fácilmente tu flujo de trabajo con tu equipo a través de todas las plataformas y aplicaciones móviles.",
        videoAndAudioCallScreenSharingModuleText: "Módulo de llamadas de video y audio y compartición de pantalla",
        webChatPlatformText: "Proporciona una interacción perfecta y sin interrupciones con tus clientes utilizando todas las opciones de comunicación como mensajería instantánea, compartición de archivos, compartición de pantalla y respuestas automáticas con la plataforma de chat web.",
        calendarAndReservationSystemText: "Sistema de calendario y reservas",
        scheduleAppointmentsText: "Crea citas con tus clientes a través de todas las plataformas, establece recordatorios y organiza automáticamente tus reuniones incluso mientras duermes con el chatbot AI.",
        webSiteAnalysisAndSegmentationText: "Análisis y segmentación del sitio web",
        analyzeWebsiteVisitorsText: "Analiza en detalle a los visitantes de tu sitio web, determina de qué fuente provienen, qué páginas y productos les interesan, y te ayuda a conocer mejor a tu público objetivo realizando una segmentación detallada.",
        advertisingAnalysisAndReportingText: "Análisis y reporte de publicidad",
        analyzeVisitorsAndAdsText: "Segmenta en detalle a los visitantes de tu sitio web y anuncios en redes sociales, analiza el comportamiento de los visitantes, calcula automáticamente el éxito y las tasas de retorno de los anuncios, y proporciona informes completos.",
        ticketManagementSystemText: "Sistema de gestión de tickets",
        manageTicketsText: "Responde a las preguntas de todas las plataformas fuera de línea en cualquier momento, recopila solicitudes de correo electrónico, SMS y WhatsApp en un solo sistema y gestiona fácilmente con el sistema de tickets.",
        webPushAndPopupModuleText: "Módulo de notificaciones push y pop-up web",
        webPushAndPopupModuleDescriptionText: "Segmenta a los visitantes de tu sitio web y toma acciones dinámicas basadas en su comportamiento, realiza recordatorios de carrito y crea desencadenantes antes de que abandonen el sitio para aumentar el compromiso.",
        reMarketingCampaignsText: "Campañas de remarketing",
        reMarketingCampaignsDescriptionText: "Llega instantáneamente a tu base de clientes con mensajes masivos de WhatsApp, correo electrónico y SMS, envía mensajes personalizados para aumentar el compromiso y gestiona fácilmente todos los procesos de comunicación desde una sola plataforma.",
        dynamicTablesText: "Tablas dinámicas",
        dynamicTablesDescriptionText: "Gestiona tus datos con tablas flexibles y personalizables, y sigue tus procesos empresariales de manera más eficiente y analítica con funciones como filtrado, clasificación y agrupación.",
        aiVoiceText: "Assistant Vocal AI",
        aiVoiceDescriptionText: "L'Assistant Vocal AI appelle automatiquement vos clients pour gérer rapidement les rendez-vous, commandes et demandes. Cette fonctionnalité simplifie les interactions avec vos clients et augmente l'efficacité de votre entreprise.",
        surveyIntroductionText: "Tenemos algunas preguntas para ofrecerte un mejor servicio.",
        sectorQuestionText: "¿En qué sector operas?",
        sectorPlaceholderText: "Introduce tu sector",
        departmentQuestionText: "¿En qué departamento trabajas en tu empresa?",
        dropdownPlaceholderText: "Selecciona opciones",
        salesOptionText: "Ventas",
        supportOptionText: "Soporte",
        itOptionText: "IT",
        softwareOptionText: "Software",
        marketingOptionText: "Marketing",
        ceoOptionText: "CEO",
        founderOptionText: "Fundador",
        managerOptionText: "Gerente",
        businessDevelopmentOptionText: "Desarrollo de negocios",
        designOptionText: "Diseño",
        otherOptionText: "Otro",
        otherSpecifyOptionText: "Otro (especificar)",
        heardAboutUsQuestionText: "¿Dónde escuchaste sobre nosotros?",
        youtubeOptionText: "YouTube",
        linkedInOptionText: "LinkedIn",
        socialMediaOptionText: "Redes sociales",
        emailMarketingOptionText: "Email marketing",
        networkRecommendationOptionText: "Recomendación de red y amigos",
        googleSearchOptionText: "Búsqueda en Google",
        finalStepsText: "Estamos completando los últimos pasos para crear el panel más adecuado para ti. Disfruta gestionando todos tus procesos empresariales fácilmente desde una sola pantalla con aplicaciones empresariales respaldadas por AI.",
        greetingText: "¡Estamos muy contentos de conocerte!",
        backLabel: "Volver",
        continueLabel: "Continuar",
        completeSetupLabel: "Completar configuración",
        technologySector: "Tecnología",
        healthSector: "Salud",
        educationSector: "Educación",
        financeSector: "Finanzas",
        productionSector: "Producción",
        retailSector: "Venta al por menor",
        tourismSector: "Turismo",
        logisticsSector: "Logística",
        ecommerceSector: "Comercio electrónico",
        mediaSector: "Medios de comunicación",
        energySector: "Energía",
        constructionSector: "Construcción",
        agricultureSector: "Agricultura",
        lawSector: "Derecho",
        consultingSector: "Consultoría",
        foodSector: "Alimentación",
        automotiveSector: "Industria automotriz",
        sportsSector: "Deportes",
    },
    ar: {
        loginInformation: "��علومات تسجيل الدخول",
        whatIsYourPurpose: "ما هو هدفك؟",
        addingASystem: "إضافة نظام",
        addingAModule: "إضافة وحدة",
        letsGetToKnowYou: "دعنا نتعرف عليك",
        name: "الاسم",
        enterYourName: "أدخل اسمك",
        surname: "اللقب",
        enterYourLastName: "أدخل لقبك",
        password: "كلمة المرور",
        passwordRedial: "إعادة إدخال كلمة المرور",
        thePasswordMustComplyWithAllClauses: "يجب أن تتوافق كلمة المرور مع جميع البنود:",
        number: "رقم",
        eightToThirtyTwoCharacters: "من 8 إلى 32 حرفًا",
        upperCase: "حرف كبير",
        youCannotUseYourUsername: "لا يمكنك استخدام اسم المستخدم الخاص بك",
        namespaceIsRequired: "مساحة الاسم مطلوبة!",
        theSurnameFieldIsRequired: "حقل اللقب مطلوب!",
        RegisteredEmail: "البريد الإلكتروني المسجل",
        siteName: "اسم الموقع",
        welcomeMessage: "مرحبًا بك في Supsis AI",
        welcomeDescription: `أود أن أتعرف عليك وأقدم لك الحلول الأنسب.<br>يرجى إدخال اسمك وتعديل معلومات تسجيل الدخول الخاصة بك.`,
        aiExpectationsTitle: "ما هي توقعاتك من تقنية Supsis AI والذكاء الاصطناعي؟",
        socialMediaManagementText: "قم بإدارة جميع وسائل التواصل الاجتماعي والتواصل مع العملاء بسهولة على شاشة واحدة",
        aiChatbotAutomationText: "قم بإدارة عملك تلقائيًا على مدار الساعة طوال أيام الأسبوع بأي لغة باستخدام روبوت الدردشة AI",
        digitalSolutionsText: "استخدم الحلول الرقمية الفعالة لمساعدة علامتي التجارية في الوصول إلى جمهور أوسع وزيادة التعرف عليها.",
        optimizeProcessesText: "قم بتحسين عملياتي التجارية وإدارة فريقي بشكل أكثر كفاءة.",
        endToEndSolutionText: "توفير حل شامل لعملي دون الحاجة إلى تدخل بشري.",
        aiTechnologyExperienceText: "اختبر المستقبل اليوم مع تقنية الذكاء الاصطناعي!",
        multipleSystemsText: `يمكنك اختيار وتجربة أنظمة متعددة.<br />جربها بدون أي تنزيلات.`,
        aiChatBotText: "روبوت الدردشة AI",
        aiChatbotManagementText: "قم بإدارة جميع المنصات والطلبات من البداية إلى النهاية باستخدام روبوت الدردشة AI بدون كود مع فريق الخبراء لدينا!",
        aiAssistantText: "مساعد AI",
        aiAssistantManagementText: "قم بإدارة جميع عملياتك التجارية بسهولة من أي منصة باستخدام مساعد AI، واحصل على مساعد فائق يوفر دعمًا مستمرًا لك ولممثليك.",
        aiLiveSupportText: "الدعم المباشر AI",
        aiLiveSupportManagementText: "قم بإدارة وتحليل والحصول على تقارير مفصلة لجميع وسائل التواصل الاجتماعي والمنصات الخاصة بك من شاشة واحدة باستخدام نظام الدعم المباشر المدعوم بالذكاء الاصطناعي.",
        aiAutomationText: "أتمتة AI",
        aiAutomationManagementText: "قم بدمج جميع سيناريوهات عملك، وربط عملياتك، وإدارة سير العمل الخاص بك تلقائيًا.",
        aiDynamicCrmText: "CRM ديناميكي AI",
        aiDynamicCrmManagementText: "قم بإدارة تواصلك مع العملاء تلقائيًا وبكفاءة باستخدام CRM الديناميكي المتكامل مع جميع الوحدات ومنصات التواصل الاجتماعي.",
        customerInteractionChannelsText: "ما هي قنوات الاتصال التي تستخدمها للتفاعل مع عملائك؟",
        multipleSystemsSelectionText: `يمكنك اختيار وتجربة أنظمة متعددة.<br>جربها بدون أي تنزيلات.`,
        platformsText: "المنصات",
        whatsappBusinessApiText: "WhatsApp Business API",
        whatsappWebText: "WhatsApp (الويب)",
        instagramIntegrationText: "تكامل Instagram",
        facebookIntegrationText: "تكامل Facebook",
        telegramIntegrationText: "تكامل Telegram",
        mailManagementSystemText: "نظام إدارة البريد",
        webChatText: "الدردشة عبر الويب",
        aiText: "الذكاء الاصطناعي",
        metaLeadTrackingText: "تتبع العملاء المحتملين Meta",
        trendyolIntegrationText: "تكامل Trendyol",
        linkedinIntegrationText: "تكامل LinkedIn",
        manageYourBusinessModulesText: "ما هي الوحدات التي تحتاجها لإدارة عملك؟",
        allModulesAiChatbotAutomationText: `استخدم جميع الوحدات، روبوت الدردشة AI، الأتمتة و <br> المنصات المتكاملة بالكامل.`,
        modulesText: "الوحدات",
        formAndSurveyModuleText: "وحدة النماذج والاستطلاعات",
        analyzeCustomerBehaviorText: "قم بتحليل سلوك العملاء بعمق باستخدام البيانات المتكاملة من جميع المنصات إلى موقعك على الويب، وفهم احتياجاتهم وتوقعاتهم بشكل أفضل، وتطوير استراتيجيات خاصة وفعالة لهم.",
        processAndTaskManagementModuleText: "وحدة إدارة العمليات والمهام",
        manageBusinessProcessesText: "حدد شروط وأولويات وقواعد عملياتك التجارية، وقم بتخطيط وتتبع وإدارة سير العمل الخاص بك بسهولة مع فريقك عبر جميع المنصات والتطبيقات المحمولة.",
        videoAndAudioCallScreenSharingModuleText: "وحدة المكالمات الفيديو والصوتية ومشاركة الشاشة",
        webChatPlatformText: "وفر تفاعلًا سلسًا ومثاليًا مع عملائك باستخدام جميع خيارات الاتصال مثل الرسائل الفورية، مشاركة الملفات، مشاركة الشاشة والردود التلقائية مع منصة الدردشة عبر الويب.",
        calendarAndReservationSystemText: "نظام التقويم والحجوزات",
        scheduleAppointmentsText: "قم بإنشاء مواعيد مع عملائك عبر جميع المنصات، وتعيين التذكيرات، وتنظيم اجتماعاتك تلقائيًا حتى أثناء نومك باستخدام روبوت الدردشة المدعوم بالذكاء الاصطناعي.",
        webSiteAnalysisAndSegmentationText: "تحليل الموقع الإلكتروني والتجزئة",
        analyzeWebsiteVisitorsText: "قم بتحليل زوار موقعك على الويب بالتفصيل، وتحديد المصدر الذي جاءوا منه، والصفحات والمنتجات التي يهتمون بها، ومساعدتك في معرفة جمهورك المستهدف بشكل أفضل من خلال إجراء تجزئة مفصلة.",
        advertisingAnalysisAndReportingText: "تحليل الإعلانات والتقارير",
        analyzeVisitorsAndAdsText: "قم بتجزئة زوار موقعك على الويب والإعلانات على وسائل التواصل الاجتماعي بالتفصيل، وتحليل سلوك الزوار، وحس��ب نجاح الإعلانات ومعدلات العائد تلقائيًا، وتقديم تقارير شاملة.",
        ticketManagementSystemText: "نظام إدارة التذاكر",
        manageTicketsText: "قم بالرد على الأسئلة من جميع المنصات في أي وقت دون اتصا��، وجمع الطلبات من البريد الإلكتروني، الرسائل القصيرة وWhatsApp في نظام واحد، وإدارتها بسهولة باستخدام نظام التذاكر.",
        webPushAndPopupModuleText: "وحدة الإشعارات الفورية والنوافذ المنبثقة عبر الويب",
        webPushAndPopupModuleDescriptionText: "قم بتجزئة زوار موقعك على الويب واتخاذ إجراءات ديناميكية بناءً على سلوكهم، وتذكيرهم بالعربة وإنشاء محفزات قبل مغادرتهم الموقع لزيادة التفاعل.",
        reMarketingCampaignsText: "حملات إعادة التسويق",
        reMarketingCampaignsDescriptionText: "قم بالوصول إلى قاعدة عملائك فورًا باستخدام رسائل WhatsApp الجماعية، البريد الإلكتروني ونظام الرسائل القصيرة، وإرسال رسائل مخصصة لزيادة التفاعل، وإدارة جميع عمليات الاتصال بسهولة من منصة واحدة.",
        dynamicTablesText: "الجداول الديناميكية",
        dynamicTablesDescriptionText: "قم بإدارة بياناتك باستخدام جداول مرنة وقابلة للتخصيص، وتتبع عملياتك التجارية بشكل أكثر كفاءة وتحليلية باستخدام ميزات مثل التصفية، الفرز والتجميع.",
        aiVoiceText: "مساعد الصوت AI",
        aiVoiceDescriptionText: "يقوم مساعد الصوت الذكي بالاتصال بعملائك تلقائيًا لمعالجة المواعيد والطلبات والاستفسارات بسرعة. هذه الميزة تبسط تفاعلات العملاء لشركتك وتزيد من الكفاءة.",
        surveyIntroductionText: "لدينا بعض الأسئلة لتقديم خدمة أفضل لك.",
        sectorQuestionText: "في أي قطاع تعمل؟",
        sectorPlaceholderText: "أدخل قطاعك",
        departmentQuestionText: "في أي قسم تعمل في شركتك؟",
        dropdownPlaceholderText: "اختر الخيارات",
        salesOptionText: "المبيعات",
        supportOptionText: "الدعم",
        itOptionText: "تكنولوجيا المعلومات",
        softwareOptionText: "البرمجيات",
        marketingOptionText: "التسويق",
        ceoOptionText: "الرئيس التنفيذي",
        founderOptionText: "المؤسس",
        managerOptionText: "المدير",
        businessDevelopmentOptionText: "تطوير الأعمال",
        designOptionText: "التصميم",
        otherOptionText: "أخرى",
        otherSpecifyOptionText: "أخرى (حدد)",
        heardAboutUsQuestionText: "أين سمعت عنا؟",
        youtubeOptionText: "YouTube",
        linkedInOptionText: "LinkedIn",
        socialMediaOptionText: "وسائل التواصل الاجتماعي",
        emailMarketingOptionText: "التسويق عبر البريد الإلكتروني",
        networkRecommendationOptionText: "توصية الشبكة والأصدقاء",
        googleSearchOptionText: "بحث Google",
        finalStepsText: "نحن نكمل الخطوات الأخيرة لإنشاء اللوحة الأنسب لك. استمتع بإدارة جميع عملياتك التجارية بسهولة من شاشة واحدة باستخدام تطبيقات الأعمال المدعومة بالذكاء الاصطناعي.",
        greetingText: "نحن سعداء جدًا بلقائك!",
        backLabel: "رجوع",
        continueLabel: "متابعة",
        completeSetupLabel: "إكمال الإعداد",
        technologySector: "تكنولوجيا",
        healthSector: "الصحة",
        educationSector: "التعليم",
        financeSector: "التمويل",
        productionSector: "الإنتاج",
        retailSector: "التجزئة",
        tourismSector: "السياحة",
        logisticsSector: "الخدمات اللوجستية",
        ecommerceSector: "التجارة الإلكترونية",
        mediaSector: "الإعلام",
        energySector: "الطاقة",
        constructionSector: "البناء",
        agricultureSector: "الزراعة",
        lawSector: "القانون",
        consultingSector: "الاستشارات",
        foodSector: "الغذاء",
        automotiveSector: "صناعة السيارات",
        sportsSector: "الرياضة",
    },
    it: {
        loginInformation: "Informazioni di accesso",
        whatIsYourPurpose: "Qual è il tuo scopo?",
        addingASystem: "Aggiunta di un sistema",
        addingAModule: "Aggiunta di un modulo",
        letsGetToKnowYou: "Conosciamoci",
        name: "Nome",
        enterYourName: "Inserisci il tuo nome",
        surname: "Cognome",
        enterYourLastName: "Inserisci il tuo cognome",
        password: "Password",
        passwordRedial: "Ripeti la password",
        thePasswordMustComplyWithAllClauses: "La password deve rispettare tutte le clausole:",
        number: "Numero",
        eightToThirtyTwoCharacters: "Da 8 a 32 caratteri",
        upperCase: "Maiuscola",
        youCannotUseYourUsername: "Non puoi usare il tuo nome utente",
        namespaceIsRequired: "Namespace richiesto!",
        theSurnameFieldIsRequired: "Il campo cognome è obbligatorio!",
        RegisteredEmail: "Email registrata",
        siteName: "Nome del sito",
        welcomeMessage: "Benvenuto in Supsis AI",
        welcomeDescription: `Vorrei conoscerti e offrirti le soluzioni più adatte.<br>Per favore, inserisci il tuo nome e modifica le tue informazioni di accesso.`,
        aiExpectationsTitle: "Quali sono le tue aspettative dalla tecnologia Supsis AI e dall'intelligenza artificiale?",
        socialMediaManagementText: "Gestisci facilmente tutti i social media e la comunicazione con i clienti su un unico schermo",
        aiChatbotAutomationText: "Gestisci automaticamente la tua attività 24/7 in qualsiasi lingua con il chatbot AI",
        digitalSolutionsText: "Utilizza soluzioni digitali efficaci per aiutare il mio marchio a raggiungere un pubblico più ampio e aumentare il suo riconoscimento.",
        optimizeProcessesText: "Ottimizza i miei processi aziendali e gestisci il mio team in modo più efficiente.",
        endToEndSolutionText: "Fornisci una soluzione end-to-end per la mia attività senza bisogno di intervento umano.",
        aiTechnologyExperienceText: "Vivi il futuro oggi con la tecnologia AI!",
        multipleSystemsText: `Puoi selezionare e provare più sistemi.<br />Sperimenta senza alcun download.`,
        aiChatBotText: "Chatbot AI",
        aiChatbotManagementText: "Gestisci tutte le piattaforme e le richieste end-to-end con il chatbot AI senza codice con il nostro team di esperti AI!",
        aiAssistantText: "Assistente AI",
        aiAssistantManagementText: "Gestisci facilmente tutti i tuoi processi aziendali da qualsiasi piattaforma con l'assistente AI e disponi di un super assistente che fornisce supporto continuo a te e ai tuoi rappresentanti.",
        aiLiveSupportText: "Supporto live AI",
        aiLiveSupportManagementText: "Gestisci, analizza e ottieni report dettagliati di tutti i tuoi social media e piattaforme da un unico schermo con il sistema di supporto live supportato dall'AI.",
        aiAutomationText: "Automazione AI",
        aiAutomationManagementText: "Integra tutti i tuoi scenari aziendali, collega i tuoi processi e gestisci il tuo flusso di lavoro automaticamente.",
        aiDynamicCrmText: "CRM dinamico AI",
        aiDynamicCrmManagementText: "Gestisci la comunicazione con i clienti automaticamente ed efficientemente con il CRM dinamico integrato con tutti i moduli e le piattaforme social.",
        customerInteractionChannelsText: "Quali canali di comunicazione utilizzi per interagire con i tuoi clienti?",
        multipleSystemsSelectionText: `Puoi selezionare e provare più sistemi.<br>Prova senza alcun download.`,
        platformsText: "Piattaforme",
        whatsappBusinessApiText: "WhatsApp Business API",
        whatsappWebText: "WhatsApp (Web)",
        instagramIntegrationText: "Integrazione Instagram",
        facebookIntegrationText: "Integrazione Facebook",
        telegramIntegrationText: "Integrazione Telegram",
        mailManagementSystemText: "Sistema di gestione della posta",
        webChatText: "Chat web",
        aiText: "Intelligenza Artificiale",
        metaLeadTrackingText: "Tracciamento lead Meta",
        trendyolIntegrationText: "Integrazione Trendyol",
        linkedinIntegrationText: "Integrazione LinkedIn",
        manageYourBusinessModulesText: "Quali moduli ti servono per gestire la tua attività?",
        allModulesAiChatbotAutomationText: `Utilizza tutti i moduli, il chatbot AI, l'automazione e <br> le piattaforme completamente integrate.`,
        modulesText: "Moduli",
        formAndSurveyModuleText: "Modulo di moduli e sondaggi",
        analyzeCustomerBehaviorText: "Analizza in profondità il comportamento dei clienti con dati integrati da tutte le piattaforme al tuo sito web, comprendi meglio le loro esigenze e aspettative e sviluppa strategie speciali ed efficaci per loro.",
        processAndTaskManagementModuleText: "Modulo di gestione dei processi e delle attività",
        manageBusinessProcessesText: "Imposta le condizioni, le priorità e le regole dei tuoi processi aziendali e pianifica, traccia e gestisci facilmente il tuo flusso di lavoro con il tuo team attraverso tutte le piattaforme e le applicazioni mobili.",
        videoAndAudioCallScreenSharingModuleText: "Modulo di chiamate video e audio e condivisione dello schermo",
        webChatPlatformText: "Offri un'interazione fluida e perfetta con i tuoi clienti utilizzando tutte le opzioni di comunicazione come messaggistica istantanea, condivisione di file, condivisione dello schermo e risposte automatiche con la piattaforma di chat web.",
        calendarAndReservationSystemText: "Sistema di calendario e prenotazioni",
        scheduleAppointmentsText: "Crea appuntamenti con i tuoi clienti attraverso tutte le piattaforme, imposta promemoria e organizza automaticamente i tuoi incontri anche mentre dormi con il chatbot supportato dall'AI.",
        webSiteAnalysisAndSegmentationText: "Analisi e segmentazione del sito web",
        analyzeWebsiteVisitorsText: "Analizza in dettaglio i visitatori del tuo sito web, determina da quale fonte provengono, quali pagine e prodotti li interessano e aiutati a conoscere meglio il tuo pubblico target effettuando una segmentazione dettagliata.",
        advertisingAnalysisAndReportingText: "Analisi e reportistica pubblicitaria",
        analyzeVisitorsAndAdsText: "Segmenta in dettaglio i visitatori del tuo sito web e delle pubblicità sui social media, analizza il comportamento dei visitatori, calcola automaticamente il successo e i tassi di ritorno delle pubblicità e fornisci report completi.",
        ticketManagementSystemText: "Sistema di gestione dei ticket",
        manageTicketsText: "Rispondi alle domande da tutte le piattaforme offline in qualsiasi momento, raccogli le richieste da email, SMS e WhatsApp in un unico sistema e gestiscile facilmente con il sistema di ticket.",
        webPushAndPopupModuleText: "Modulo di notifiche push e popup web",
        webPushAndPopupModuleDescriptionText: "Segmenta i visitatori del tuo sito web e prendi azioni dinamiche in base al loro comportamento, fai promemoria del carrello e crea trigger prima che lascino il sito per aumentare il coinvolgimento.",
        reMarketingCampaignsText: "Campagne di remarketing",
        reMarketingCampaignsDescriptionText: "Raggiungi istantaneamente la tua base clienti con messaggi WhatsApp di massa, email e sistema SMS, invia messaggi personalizzati per aumentare il coinvolgimento e gestisci facilmente tutti i processi di comunicazione da un'unica piattaforma.",
        dynamicTablesText: "Tabelle dinamiche",
        dynamicTablesDescriptionText: "Gestisci i tuoi dati con tabelle flessibili e personalizzabili e traccia i tuoi processi aziendali in modo più efficiente e analitico con funzionalità come filtraggio, ordinamento e raggruppamento.",
        aiVoiceText: "Assistente Vocale AI",
        aiVoiceDescriptionText: "L'Assistente Vocale AI chiama automaticamente i tuoi clienti per gestire rapidamente appuntamenti, ordini e richieste. Questa funzionalità semplifica le interazioni con i clienti per la tua azienda e aumenta l'efficienza.",
        surveyIntroductionText: "Abbiamo alcune domande per fornirti un servizio migliore.",
        sectorQuestionText: "In quale settore operi?",
        sectorPlaceholderText: "Inserisci il tuo settore",
        departmentQuestionText: "In quale reparto lavori nella tua azienda?",
        dropdownPlaceholderText: "Seleziona le opzioni",
        salesOptionText: "Vendite",
        supportOptionText: "Supporto",
        itOptionText: "IT",
        softwareOptionText: "Software",
        marketingOptionText: "Marketing",
        ceoOptionText: "CEO",
        founderOptionText: "Fondatore",
        managerOptionText: "Manager",
        businessDevelopmentOptionText: "Sviluppo aziendale",
        designOptionText: "Design",
        otherOptionText: "Altro",
        otherSpecifyOptionText: "Altro (specifica)",
        heardAboutUsQuestionText: "Dove hai sentito parlare di noi?",
        youtubeOptionText: "YouTube",
        linkedInOptionText: "LinkedIn",
        socialMediaOptionText: "Social Media",
        emailMarketingOptionText: "Email Marketing",
        networkRecommendationOptionText: "Raccomandazione di rete e amici",
        googleSearchOptionText: "Ricerca Google",
        finalStepsText: "Stiamo completando gli ultimi passaggi per creare il pannello più adatto a te. Goditi la gestione di tutti i tuoi processi aziendali facilmente da un unico schermo con applicazioni aziendali supportate dall'AI.",
        greetingText: "Siamo molto felici di conoscerti!",
        backLabel: "Indietro",
        continueLabel: "Continua",
        completeSetupLabel: "Completa la configurazione",
        technologySector: "Tecnologia",
        healthSector: "Salute",
        educationSector: "Istruzione",
        financeSector: "Finanza",
        productionSector: "Produzione",
        retailSector: "Vendita al dettaglio",
        tourismSector: "Turismo",
        logisticsSector: "Logistica",
        ecommerceSector: "Commercio elettronico",
        mediaSector: "Media",
        energySector: "Energia",
        constructionSector: "Costruzioni",
        agricultureSector: "Agricoltura",
        lawSector: "Legge",
        consultingSector: "Consulenza",
        foodSector: "Alimentare",
        automotiveSector: "Industria automobilistica",
        sportsSector: "Sport",
    },
};
export default messages;